import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import {
  SUPABASE_URL,
  SUPABASE_ANON_KEY,
  SERVER_API_URL,
} from '@renderer/config';
import { SupabaseUtil } from '@sdk';

let _client: SupabaseClient | null = null;

function getClient(): SupabaseClient {
  if (!_client) {
    if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
      console.error('Missing Supabase credentials:', {
        SUPABASE_URL,
        SUPABASE_ANON_KEY,
      });
    }
    _client = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
    console.log('Supabase client initialized');
  }
  return _client;
}

try {
  SupabaseUtil.init(getClient(), SERVER_API_URL);
  console.log('SupabaseUtil initialized successfully');
} catch (err) {
  console.error('Error initializing SupabaseUtil:', err);
}

const db = SupabaseUtil.instance.db;
const fetcher = SupabaseUtil.instance.fetcher;

export const Utils = {
  request: fetcher.request,
  useFetch: fetcher.useFetch,
  post: fetcher.post,
  patch: fetcher.patch,
  delete: fetcher.delete,
  db,
};